/* eslint-disable max-len */
import { FilePdfOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';
import moment from 'moment';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { IZadostResp, nzdownloadPDF } from 'services/nezarazenyUcet/nuZapis';

interface IZapisPrehled {
    zadostData?: IZadostResp;
    stav: string;
}

const ZapisPrehled: React.FC<IZapisPrehled> = props => {
    const { zadostData, stav } = props;
    const history = useHistory();
    const [errStatus, setErrStatus] = useState<number>();
    const { token } = useParams<{ token: string }>(); // Bank ID token sebran z urlky
    const [loading, setLoading] = useState<boolean>(false);

    const routeChangeLoginPage = () => {
        let path = zadostData?.zadostid
            ? '/nezarazeny-ucet-zapis/idzadost/' + zadostData.zadostid
            : '/nezarazeny-ucet-zapis/idzadost/';
        history.push(path);
    };

    const routeChange = () => {
        let path = '/siroka-verejnost/sluzby-pro-sirokou-verejnost/';
        window.open(path, '_parent');
    };

    const protokolDownload = () => {
        setLoading(true);
        nzdownloadPDF('pdf', token, 'protokol')
            .then(() => {
                setLoading(false);
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            });
    };

    const fakturaDownload = () => {
        setLoading(true);
        nzdownloadPDF('pdf', token, 'faktura')
            .then(() => {
                setLoading(false);
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            });
    };
    return (
        <>
            {errStatus ? (
                <Col span={24}>
                    <Row>
                        {errStatus === 400 ? (
                            <Title text="RESPONSE_ERROR_400" level={3} />
                        ) : errStatus === 401 ? (
                            <Title text="RESPONSE_ERROR_401" level={3} />
                        ) : errStatus === 404 ? (
                            <Title text="RESPONSE_ERROR_404" level={3} />
                        ) : errStatus === 500 ? (
                            <Title text="RESPONSE_ERROR_500" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChangeLoginPage} />
                    </Row>
                </Col>
            ) : stav ? (
                <>
                    <h1>
                        <TranslateText>STAV_NADPIS</TranslateText>
                    </h1>
                    <div>
                        {stav === 'CEKA' ? ( // Stav CEKA
                            <>
                                <Paragraph text="STAV_CEKA" />

                                <Row className="statement-buttons-row">
                                    <ButtonComponent buttontext="OK" onClick={routeChange} />
                                </Row>
                            </>
                        ) : stav === 'DUPL' ? ( // Stav DUPL
                            <>
                                <Paragraph text="STAV_DUPL" />

                                <Row className="statement-buttons-row">
                                    <ButtonComponent buttontext="OK" onClick={routeChange} />
                                </Row>
                            </>
                        ) : stav === 'ZPRAC' ? ( // Stav ZPRAC
                            <>
                                <Row>
                                    <Col span={24} className="detail">
                                        <TranslateText>STAV_ZU_1</TranslateText>{' '}
                                        <TranslateText>
                                            {moment(zadostData?.platnostDo).format('DD.MM.YYYY')}
                                        </TranslateText>
                                        .
                                    </Col>
                                </Row>

                                <Row>
                                    <Col span={24} className="detail">
                                        <TranslateText>STAV_ZU_2</TranslateText>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24} className="detail">
                                        <TranslateText>STAV_ZU_3</TranslateText>
                                    </Col>
                                </Row>

                                <LoadingWrapper loading={loading} download={true}>
                                    <div className="files">
                                        <Row className="file-row" align="middle">
                                            <Col span={1} className="file-detail" onClick={protokolDownload}>
                                                <FilePdfOutlined />
                                            </Col>
                                            <Col span={11} className="file-detail" onClick={protokolDownload}>
                                                <Paragraph text="Protokol.pdf" strong={true} />
                                            </Col>
                                            <Col span={10}>
                                                <></>
                                            </Col>
                                        </Row>

                                        <Row className="file-row" align="middle">
                                            <Col span={1} className="file-detail" onClick={fakturaDownload}>
                                                <FilePdfOutlined />
                                            </Col>
                                            <Col span={11} className="file-detail" onClick={fakturaDownload}>
                                                <Paragraph text="Faktura.pdf" strong={true} />
                                            </Col>
                                            <Col span={10}>
                                                <></>
                                            </Col>
                                        </Row>
                                    </div>
                                </LoadingWrapper>
                            </>
                        ) : stav === 'VYPR' ? ( // Stav VYPR
                            <>
                                <Paragraph text="STAV_VYPR" />

                                <Row className="statement-buttons-row">
                                    <ButtonComponent buttontext="OK" onClick={routeChange} />
                                </Row>
                            </>
                        ) : stav === 'BINEPO' ? ( // Stav BINEPO
                            <>
                                <Paragraph text="Pro zpracování služby jste neposkytli všechny požadované údaje. V žádosti nelze pokračovat." />
                                <Row className="statement-buttons-row">
                                    <ButtonComponent buttontext="OK" onClick={routeChange} />
                                </Row>
                            </>
                        ) : (
                            <>
                                <Paragraph text="Neobdrželi jsme prostřednictvím Vaší BI všechny požadované údaje. Pro další informace nás kontaktujte prostřednictvím" />
                                <a href="mailto:cdcp@cdcp.cz">cdcp@cdcp.cz</a>.
                            </>
                        )}
                    </div>
                </>
            ) : (
                <>
                    <h1>
                        <TranslateText>STAV_NADPIS</TranslateText>
                    </h1>
                    <TranslateText>NEZNAMY_STAV</TranslateText>
                </>
            )}
        </>
    );
};

export default ZapisPrehled;
